import React from 'react';
import { FooterStyle } from './footer.style';

const Footer = () => (
  <FooterStyle>
    <footer>
      <p>Made with ♥ by me</p>
    </footer>
  </FooterStyle>
);

export default Footer;
